import React, { useState } from "react";
import { Link } from "react-router-dom";

import styles from "./css/navbar.module.scss";

const Navbar = ({ navBar, isFixed }) => {
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  return (
    <nav className={styles.navbar}>
      <ul className={styles.navList}>
        {navBar.map((item, i) => (
          <NavItem
            isFixed={isFixed}
            key={i}
            item={item}
            index={i}
            isOpen={openDropdownIndex === i}
            onOpen={() => setOpenDropdownIndex(i)}
            onClose={() => setOpenDropdownIndex(null)}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;

const NavItem = ({ item, isFixed, index, isOpen, onOpen, onClose }) => {
  if (item.type === "dropdown")
    return (
      <DropdownNavItem
        isFixed={isFixed}
        item={item}
        index={index}
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
    );
  if (item.type === "link" && item.tag === "animate")
    return <TrendingNavItem item={item} />;
  if (item.type === "link") return <LinkNavItem item={item} />;
  if (item.type === "anchor") return <AnchorNavItem item={item} />;
  return null;
};

const LinkNavItem = ({ item }) => (
  <li className={styles.navItem}>
    <Link
      to={`${process.env.PUBLIC_URL}/` + item.link}
      className={styles.navLink}
    >
      <span>{item.heading}</span>
    </Link>
  </li>
);

const AnchorNavItem = ({ item }) => (
  <li className={styles.navItem}>
    <a
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.navLink}
    >
      <span>{item.heading}</span>
    </a>
  </li>
);

const DropdownNavItem = ({ item, isFixed, isOpen, onOpen, onClose }) => {
  const hideMenu = () => {
    onClose();
  };

  return (
    <li
      className={`${styles.navItem} ${styles.hasDropdown} ${isOpen ? styles.dropdownOpen : ""}`}
      onMouseEnter={onOpen}
      onMouseLeave={onClose}
    >
      <Link
        to={`${process.env.PUBLIC_URL}/` + item.link}
        className={styles.navLink}
        onClick={hideMenu}
      >
        <span>{item.heading}</span>
        <svg
          className={styles.chevron}
          width="10"
          height="6"
          viewBox="0 0 10 6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L5 5L9 1"
            stroke="currentColor"
            strokeWidth="1.2"
            fill="none"
          />
        </svg>
      </Link>
      <MegaMenu
        isFixed={isFixed}
        item={item}
        onLinkClick={hideMenu}
        isOpen={isOpen}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
      />
    </li>
  );
};

const MegaMenu = ({
  item,
  onLinkClick,
  isFixed,
  isOpen,
  onMouseEnter,
  onMouseLeave,
}) => {
  const col1Groups = item.subCategoryCol1
    ? splitByHeadings(item.subCategoryCol1.list)
    : [];
  const col2Groups = item.subCategoryCol2
    ? splitByHeadings(item.subCategoryCol2.list)
    : [];

  const exploreItems = [];
  if (item.subCategoryCol1 && item.subCategoryCol1.link)
    exploreItems.push(item.subCategoryCol1.link);
  if (item.subCategoryCol2 && item.subCategoryCol2.link)
    exploreItems.push(item.subCategoryCol2.link);

  return (
    <div
      className={`${styles.megaMenu} ${isFixed ? styles.megaMenuFixed : ""} ${isOpen ? styles.megaMenuOpen : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="custom-container">
        <div className={styles.megaMenuInner}>
          <div className={styles.menuColumns}>
            {item.subCategoryCol0 && (
              <MenuColumn
                heading="CATEGORY"
                items={item.subCategoryCol0}
                onLinkClick={onLinkClick}
              />
            )}

            {col1Groups.length > 0 && (
              <div className={styles.menuColumnGroup}>
                {col1Groups.map((group, i) => (
                  <MenuColumn
                    key={`c1-${i}`}
                    heading={group.heading}
                    items={group.items}
                    onLinkClick={onLinkClick}
                  />
                ))}
              </div>
            )}

            {col2Groups.length > 0 && (
              <div className={styles.menuColumnGroup}>
                {col2Groups.map((group, i) => (
                  <MenuColumn
                    key={`c2-${i}`}
                    heading={group.heading}
                    items={group.items}
                    onLinkClick={onLinkClick}
                  />
                ))}
              </div>
            )}

            {exploreItems.length > 0 && (
              <MenuColumn
                heading="Explore"
                items={exploreItems}
                onLinkClick={onLinkClick}
              />
            )}
          </div>

          {item.src && (
            <MenuPromo
              src={item.src}
              heading={item.heading}
              quickLink={item.quickLink}
              onLinkClick={onLinkClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const MenuColumn = ({ heading, items, onLinkClick }) => (
  <div className={styles.menuColumn}>
    {heading && <h4 className={styles.columnHeading}>{heading}</h4>}
    <ul className={styles.columnList}>
      {items.map((sub, j) => (
        <li key={j}>
          <Link
            to={`${process.env.PUBLIC_URL}/` + sub.link}
            onClick={onLinkClick}
          >
            {sub.category || sub.name}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const MenuPromo = ({ src, heading, quickLink, onLinkClick }) => (
  <div className={styles.menuPromo}>
    <div className={styles.promoImageWrap}>
      <img src={`${process.env.PUBLIC_URL}/` + src} alt={heading} />
    </div>
    {quickLink && (
      <Link
        to={`${process.env.PUBLIC_URL}/` + quickLink.link}
        className={styles.promoLink}
        onClick={onLinkClick}
      >
        {quickLink.name}
      </Link>
    )}
  </div>
);

const TrendingNavItem = ({ item }) => (
  <li className={`${styles.navItem} ${styles.trendingItem}`}>
    <Link
      to={`${process.env.PUBLIC_URL}/` + item.link}
      className={styles.trendingLink}
    >
      {item.heading}
    </Link>
  </li>
);

// Group flat list items into { heading, items[] } sections split by type:"heading"
const splitByHeadings = (list) => {
  const groups = [];
  let current = null;

  list.forEach((item) => {
    if (item.type === "heading") {
      current = { heading: item.category, items: [] };
      groups.push(current);
    } else if (current) {
      current.items.push(item);
    }
  });

  return groups;
};
